<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.tanggal,
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="Project Code">
          <a-input
            v-decorator="[
              'project_nm',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.project_nm,
              },
            ]"
          ></a-input>
        </a-form-item> -->
        <a-form-item label="Pipeline No.">
          <a-select
            v-decorator="[
              'pipeline',
              {
                rules: [
                  { required: true, message: 'Pipeline Name Required' },
                ],
                initialValue: initialData.informasi.pipeline,
              },
            ]"
            showSearch
            option-filter-prop="children" :filter-option="filterOption"
            @change="handleChangepipeline"
            :disabled="sn_id!=undefined"
          >
            <a-select-option
              v-for="item in listPipeline"
              :key="item.pipeline_id"
              :value="item.pipeline_id"
              >{{ item.pipeline_no }} - {{ item.definitions }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            v-decorator="[
              'deskripsi',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.deskripsi,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Customer Name">
          <a-select
            v-decorator="[
              'customer_id',
              {
                rules: [
                  { required: true, message: 'Customer Name Required' },
                ],
                initialValue: initialData.informasi.customer_id,
              },
            ]"
            showSearch
            option-filter-prop="children" :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in listCustomer"
              :key="item.customer_id"
              :value="item.customer_id"
              >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Due Date Delivery">
          <!-- <a-input
            v-decorator="[
              'due_date_insp',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date_insp,
              },
            ]"
          ></a-input> -->
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'due_date_insp',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.due_date_insp,
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Spesial Requirement">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="[
              'special_requirement',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.special_requirement,
              },
            ]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Estimated Contract Value">
          <!-- <a-input
            v-decorator="[
              'estimate_project_val',
              {
                rules: [],
                initialValue: initialData.informasi.estimate_project_val,
              },
            ]"
          ></a-input> -->
          <a-input-number
            :max="999999999999"
            :min="0"
            class="m-width-full"
            v-decorator="[
              'estimate_project_val',
              {
                rules: [{ required: true },{validator: validRatherThenzero} ],
                initialValue: initialData.informasi.estimate_project_val,
              },
            ]"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            @change="changeestcontrak"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="Estimated Project Cost (%)">
          <div style="display: flex;gap:16px">
            <a-input-number
              :min="0"
              :max="100"
              class="m-text-align-right" style="width: 30%;"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              @keydown="onlyNumber"
              @change="changeprosen"
              v-decorator="['prosentase_project_cost', { rules: [{ required: true }], initialValue: initialData.informasi.prosentase_project_cost }]"
            ></a-input-number>
              <a-input-number
                :min="0"
                class="m-text-align-right" style="width: 70%"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                disabled
                v-decorator="['estimate_project_cost', { rules: [{ required: true }], initialValue: initialData.informasi.estimate_project_cost }]"
              ></a-input-number>
          </div>
        </a-form-item>
        <a-form-item label="Bid Reasoning">
          <a-auto-complete
            v-decorator="[
              'bid_reasoning',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.bid_reasoning,
              },
            ]"
            class="certain-category-search"
            dropdownClassName="certain-category-search-dropdown"
            :dropdownMatchSelectWidth="false"
            placeholder="input here"
            optionLabelProp="value"
          >
            <template #dataSource>
              <a-select-option v-for="(cust, index) in listAutoBidReasoning" :key="index" :value="cust.bid_reasoning.trim()">
                {{ cust.bid_reasoning.trim() }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </a-form-item>
        <a-form-item label="UP/RFQ Number">
          <a-input
            v-decorator="[
              'up_rfq_no',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.up_rfq_no,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Executor Site">
          <a-select
            :disabled="mode === 'Edit' ? true : false"
            class="m-width-full"
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          >
            <a-select-option value="Site Surabaya"
              >Site Surabaya</a-select-option
            >
            <a-select-option value="Site Jakarta">Site Jakarta</a-select-option>
          </a-select>
          <!-- <a-input
            v-decorator="[
              'executor_site',
              {
                rules: [{ required: true }],
                initialValue: initialData.informasi.executor_site,
              },
            ]"
          ></a-input> -->
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "Informasi",
  props: {
    data: {},
    persetujuan: {},
    listCustomer: {},
    listPipeline: {},
    listAutoBidReasoning: {},
    mode: String,
    sn_id: String,
    cust_id: String
  },
  mixins: [GlobalMethod,],
  data() {
    return {
      activeProject: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat"]),
    initialData() {
      let informasi = {};
      let pimpinan = {};
      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          tanggal: moment(),
          pipeline: "",
          //project_nm: "",
          deskripsi: "",
          customer_nm: "",
          customer_id: "",
          due_date_insp: "",
          special_requirment: "",
          estimate_project_val: "0",
          estimate_project_cost: "0",
          bid_reasoning: "",
          up_rfq_no: "",
          executor_site: "",
          prosentase_project_cost: "",
        };
        return { informasi };
      } else {
        informasi = {
          tanggal: moment(this.data.tanggal),
          pipeline: this.data.pipeline?this.data.pipeline:this.data.pipeline_id,
          //project_nm: this.data.project_nm,
          deskripsi: this.data.deskripsi,
          customer_nm: this.data.customer_nm,
          customer_id: this.data.customer_id,
          due_date_insp: moment(this.data.due_date_insp),
          special_requirement: this.data.special_requirement,
          estimate_project_val: this.data.estimate_project_val,
          estimate_project_cost: this.data.estimate_project_cost,
          bid_reasoning: this.data.bid_reasoning,
          up_rfq_no: this.data.up_rfq_no,
          executor_site: this.data.executor_site,
          prosentase_project_cost: this.data.prosentase_project_cost ? this.data.prosentase_project_cost : this.data.prosentase_est_cost,
        };

        // if (this.persetujuan === undefined || this.persetujuan.length <= 0) {
        //   pimpinan = {
        //     bod: "",
        //     pimpro: "",
        //   };
        // } else {
        //   pimpinan = {
        //     bod: this.persetujuan.bod,
        //     pimpro: this.persetujuan.pimpro,
        //   };
        // }

        return { informasi, pimpinan };
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_PRODUK");
  },
  methods: {
    moment,
    handleProject(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.initialData.pimpinan.pimpro = filter[0].pimpro;
      this.initialData.pimpinan.bod = filter[0].bod;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let csnm = _.filter(this.listCustomer,(e)=> e.customer_id==values.customer_id)
        values.customer_nm = csnm[0].customer_nm
        Event.$emit("SalesNotifData", {
          informasi: values,
        });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangepipeline(item){
      let el = _.filter(this.listPipeline, (e)=> e.pipeline_id == item)
      this.form.setFieldsValue({
        deskripsi: el[0].description,
        estimate_project_val: el[0].est_contract_value,
        estimate_project_cost: el[0].estimate_gross_profit,
        prosentase_project_cost: (el[0].estimate_gross_profit_prosen==null && el[0].estimate_gross_profit!="" ? (el[0].estimate_gross_profit/el[0].est_contract_value*100): el[0].estimate_gross_profit_prosen)
      });
    },
    changeprosen(val){
      let est_contract_value = this.form.getFieldValue("estimate_project_val");
      this.form.setFieldsValue({estimate_project_cost:(val/100)*(est_contract_value ? est_contract_value : 0)})
    },
    changeestcontrak(val){
      let prosentase_project_cost = this.form.getFieldValue("prosentase_project_cost");
      console.log("xxxxx",prosentase_project_cost, val)
      this.form.setFieldsValue({estimate_project_cost: prosentase_project_cost ? (prosentase_project_cost/100)*val : 0})
    }
  },
  watch: {
    "listPipeline"(){
      if(this.sn_id){
        let cust = _.filter(this.listCustomer,(item)=> item.customer_nm==this.cust_id)
        if(cust.length>0) {
          cust = cust[0].customer_id
        }else{
          cust = null
        }
        this.form.setFieldsValue({
            customer_id: cust,
            pipeline: this.sn_id
          });
        this.handleChangepipeline(this.sn_id)
      }
    }
  }
};
</script>

<style>
</style>